import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
            Proposal_For : "",
            Agent_SP_Name : "",
            Bank_Name : "",
            Branch_Name : "",
            Zone_Name : "",
            Proposer_Full_Name : "",
            FullName_Of_Diffrent_Propser : "",
            Name_of_SP_Agent : "",
            Proposal_Form_Number : "",
            Sp_Certificate_Num_Agent_Code : "",
            Confirmation_Status : false,
            SP_Agent_Number:""
}

const esirProposaFormRecmnd = (state, action) => {
    return updateObject(state, {
      ...action.payload
    });
  };


const reducer = (state = initialState, action) => {
    switch (action.type) {
      // lead
      case actionTypes.ADD_ESIR_PROPOSAL_FORM:
        return esirProposaFormRecmnd(state, action);
  
      default:
        return state;
    }
  };
  
  export default reducer;


